<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMore from '../common/CheckMore.vue'

import { getPageThemeColor, getShadowColor } from '@/utils/modules/getStyles'
import { parseTime } from '@/utils/common'

export default {
  name: 'Comp8',
  components: { ModuleTitle, CheckMore },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      nowYear: ''
    }
  },
  mounted() {
    const now = new Date()
    this.nowYear = parseTime(now, '{y}')
  },
  methods: { getPageThemeColor, getShadowColor }
}
</script>

<template>
  <div class="modules-id-8">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-3 modules-id-8-content">
      <div class="list-title-content">
        <p class="list-title-item">序号</p>
        <p class="list-title-item">{{ `${nowYear}年民生实事` }}</p>
        <p class="list-title-item">负责人</p>
        <p class="list-title-item">完成时限</p>
      </div>
      <div class="list-content">
        <div
          v-for="(v, i) in moduleOption.list.slice(0, 3)"
          :key="`modules-8-${v.id}`"
          class="item"
          :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        >
          <p class="item-order" :style="{color: getPageThemeColor(path)}">{{ i + 1 }}</p>
          <p class="item-title h-line-2">{{ v.headline || '' }}</p>
          <p class="item-name">{{ v.name || '' }}</p>
          <p class="item-time">{{ v.time | formatDate('yyyy-MM') }}</p>
        </div>
      </div>
      <check-more class="check-more-f" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-8-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.list-title-content {
  width: 455px;
  display: grid;
  grid-template-columns: 72px 218px 82px 1fr;
  .list-title-item {
    font-size: 14px;
    font-weight: 800;
    color: var(--grey-text-color);
    text-align: start;
    box-sizing: border-box;
  }
  .list-title-item:first-child {
    padding-left: 8px;
  }
}

.list-content {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin-top: 20px;
  .item {
    width: 455px;
    height: 64px;
    border-radius: 5px;
    background-color: #fff;
    display: grid;
    grid-template-columns: 72px 218px 82px 1fr;
    align-items: center;
    .item-order {
      font-size: 17px;
      font-weight: 800;
      padding-left: 16px;
      box-sizing: border-box;
    }
    .item-title, .item-name, .item-time {
      width: 80%;
      font-size: 13px;
      font-weight: 600;
      color: #000;
      text-align: start;
      line-height: 18px;
    }
    .item-name, .item-time {
      font-size: 14px;
    }
  }
}

.check-more-f {
  margin-top: 20px;
}
</style>
